module.exports = require('./helpers/bundle-url').getBundleURL('73sox') + "logo.c51670a8.svg";